import toasteventbus from 'primevue/toasteventbus';

export default class Toast {
  static info(detail: string, life: number | undefined = undefined) {
    toasteventbus.emit('add', { severity: 'info', summary: 'Info', detail, life });
  }

  static warn(detail: string, life: number | undefined = undefined) {
    toasteventbus.emit('add', { severity: 'warn', summary: 'Warning', detail, life });
  }

  static success(detail: string, life: number | undefined = undefined) {
    toasteventbus.emit('add', {
      severity: 'success',
      summary: 'Success',
      detail,
      life
    });
  }

  static error(detail: string, life: number | undefined = undefined) {
    toasteventbus.emit('add', { severity: 'error', summary: 'Error', detail, life });
  }
}